module.exports = __webpack_public_path__ + "media/images/common/logo_header_mobile-7bff0acff231b81675a199a73ebeadf8.png";